const ClassMap = {
  nav: '[data-jsmodule="main-nav"]',
  hamburger: '[data-jsmodule="hamburger"]',
  menuItem: '[data-jsmodule="menu-item"]',
  submenu: '[data-jsmodule="submenu"]',
}

const mount = () => {
  console.log('Mounted')
  document.addEventListener('click', handleClick)
}

const handleClick = (event) => {
  const { target } = event

  const hamburger = target.closest(ClassMap.hamburger)
  if (hamburger) {
    const nav = document.querySelector(ClassMap.nav)
    toggleHamburgerMenu(nav, hamburger)
    return
  }

  const menuItem = target.closest(ClassMap.menuItem)
  if (menuItem) {
    const menuButtons = document.querySelectorAll(ClassMap.menuItem)
    toggleSubmenu(menuItem, menuButtons)
    return
  }

  const isOutsideNav = !target.closest(ClassMap.nav)
  if (isOutsideNav) {
    const nav = document.querySelector(ClassMap.nav)
    const hamburgerEl = document.querySelector(ClassMap.hamburger)
    const menuButtons = document.querySelectorAll(ClassMap.menuItem)

    nav?.classList.remove('show')
    hamburgerEl?.setAttribute('aria-expanded', 'false')
    closeAllMenus(menuButtons)
    document.body.style.overflow = ''
  }
}

const toggleHamburgerMenu = (nav, hamburger) => {
  const expanded = nav.classList.toggle('show')
  hamburger.setAttribute('aria-expanded', expanded)
  document.body.style.overflow = expanded ? 'hidden' : ''
}

const toggleSubmenu = (menuItem, menuButtons) => {
  const submenu = menuItem.nextElementSibling
  const isOpen = submenu?.classList.contains('show')

  closeAllMenus(menuButtons)

  if (!isOpen && submenu) {
    submenu.classList.add('show')
    menuItem.setAttribute('aria-expanded', 'true')
    submenu.querySelector('a')?.focus()
  }
}

const closeAllMenus = (menuButtons) => {
  document.querySelectorAll(ClassMap.submenu).forEach((element) => element.classList.remove('show'))
  menuButtons.forEach((button) => button.setAttribute('aria-expanded', 'false'))
}

export default { mount }
